export default {
  allAvailableArticleImagesAPI: () => '/index/model',
  defaultGridLayout           : 'wall',
  editPanelCardsAPI           : () => '/index/model',
  maxTextSizeForOneRow        : 80,
  publicationAPI              : params => `/api/v1/hubs/${params.id}`,
  publicationItemFullDataAPI  : params => `/index/model?publicationItemId=${params.id}`,
  publicationsAPI             : () => '/index/model',
  publicationSectionAPI       : params => `/api/v1/hubs/${params.publicationId}/sections/${params.sectionId}`,
  publicationSectionsAPI      : params => `/index/model?publicationId=${params.publicationId}`,
  publicationSectionItemAPI   : params => '/index/model',
  publicationSectionItemsAPI  : params => '/index/model',
};



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/app.settings.ts